import { MDSToggleProps } from "./toggle.types";
import { StyledToggle } from "./toggle.style";

export const MDSToggle = (props: MDSToggleProps) => {
  const { ...rest } = props;
  return (
    <StyledToggle
      type="checkbox"
      // these handlers on the mouse-down and on-click fix a rare issue where the onChange is not called
      onMouseDown={e => {
        e.preventDefault();
      }}
      onClick={e => e.stopPropagation()}
      {...rest}
    />
  );
};
